import React from 'react';
import PropTypes from 'prop-types';

const ComponentNotFound = ({ data: { _type } }) => (
  <div>
    {`Component ${_type} is not defined. Add it to components.js`}
  </div>
);

ComponentNotFound.propTypes = {
  data: PropTypes.shape({
    _type: PropTypes.string,
  }).isRequired,
};

export default ComponentNotFound;
